import React from 'react'
import icon from '../../assets/Group 1410097580.png'
import './css/Quotes.css'

export default function Quotes() {
  return (
    <div className="quote" >
      <div className="customcontainer">

        <div className="quote-content">
          <h2 className="quote-title" data-aos="fade-up">“ एक कदम मानवता की ओर ”</h2>

          <p className="quote-text" data-aos="fade-up">
            Guided by the profound wisdom of Param Pujya Khatargachhadhipati Acharya Shri Jinmaniprabh Surishwar Ji Maharaj Saheb and Param Pujya Shashi Prabhi Ji Maharaj Saheb, who believe that the inclination toward selfless service is the highest form of human grace.
          </p>

          <p className="quote-text" data-aos="fade-up">
          Inspired by this light, Veer Samyak Foundation was established in 2019 to transform noble intent into a sanctuary for those seeking support and dignity.

          </p>
        </div>

        

      </div>
    </div>
  )
}
